import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { loginActions } from '../../action/loginAction';
import { appVariables } from '../../helpers/appVariables';


class Aboutsupermega extends Component {

    render() {
        const { t, i18n } = this.props;
        return (

            <div class="gameSelctionContPly">
                 { i18n.language === 'th' ?
                <>
                        <div class="gameSelectPly">
                            <span><img src="./assets/img/icons/abt-1.png" /></span>
                            <p>ซื้อในราคา USD {appVariables.PRIZE_STRUCT_SUPERMEGA.BetAmount} เพื่อเข้าร่วมการจับรางวัลหลักประจำสัปดาห์ของเราในครั้งเดียว!</p>
                        </div>
                        <div class="gameSelectPly">
                            <span><img src="./assets/img/icons/Select Icon.png" /></span>
                            <p>เลือก {appVariables.PRIZE_STRUCT_SUPERMEGA.BallSelectCount} หมายเลข - เลกระหว่าง {appVariables.PRIZE_STRUCT_SUPERMEGA.StartBall} ถึง {appVariables.PRIZE_STRUCT_SUPERMEGA.EndBall} ต่อหนึ่งตั๋ว หรือคุณสามารถคลิกที่ไอคอนสุ่ม "∝" แล้วเราจะเลือกหมายเลขให้คุณ</p>
                        </div>
                        <div class="gameSelectPly">
                            <span><img src="./assets/img/icons/Stars Icon.png" /></span>
                            <p>จับคู่หมายเลขในลำดับใดก็ได้เพื่อรับรางวัลใหญ่ USD {appVariables.PRIZE_STRUCT_SUPERMEGA.MainDrawWin.FstPrize.replace('#', ' Million')}*</p>
                        </div>
                        <div class="gameSelectPly">
                            <span><img src="./assets/img/icons/Winner Icon.png" /></span>
                            <p>ผู้ชนะทุกคนจะได้รับรางวัลเมื่อจับคู่หมายเลขได้สองตัวในลำดับใดก็ได้</p>
                        </div>
                        <div class="gameSelectPly">
                            <span><img src="./assets/img/icons/Frame (1).png" /></span>
                            <p>การจับรางวัลจะจัดขึ้นทุกสัปดาห์ในวันเสาร์ เวลา 03:30 น. (UTC)</p>
                        </div>
                        <div class="gameSelectPly">
                            <span><img src="./assets/img/icons/sustainability.png" /></span>
                            <p>รับชมการจับรางวัลสดได้ทางช่อง YouTube และเพจ Facebook ของเรา</p>
                        </div>
                    </>

                :
                i18n.language === 'tl' ?
                    <>
                            <div class="gameSelectPly">
                                <span><img src="./assets/img/icons/abt-1.png" /></span>
                                <p>Bumili para sa USD {appVariables.PRIZE_STRUCT_SUPERMEGA.BetAmount} upang makasali sa aming lingguhang MAIN DRAW nang isang bagsakan!</p>
                            </div>
                            <div class="gameSelectPly">
                                <span><img src="./assets/img/icons/Select Icon.png" /></span>
                                <p>Pumili ng {appVariables.PRIZE_STRUCT_SUPERMEGA.BallSelectCount} Numero - Pumili sa pagitan ng {appVariables.PRIZE_STRUCT_SUPERMEGA.StartBall} hanggang {appVariables.PRIZE_STRUCT_SUPERMEGA.EndBall} bawat tiket. O maaari mong i-click ang randomization na icon na "∝" at kami ang pipili ng iyong mga numero para sa iyo.</p>
                            </div>
                            <div class="gameSelectPly">
                                <span><img src="./assets/img/icons/Stars Icon.png" /></span>
                                <p>Ipares ang mga ito sa ANUMANG AYOS upang manalo ng Grand Prize na USD {appVariables.PRIZE_STRUCT_SUPERMEGA.MainDrawWin.FstPrize.replace('#', ' Million')}*</p>
                            </div>
                            <div class="gameSelectPly">
                                <span><img src="./assets/img/icons/Winner Icon.png" /></span>
                                <p>Bawat nanalo ay makakatanggap ng premyo kapag nakapareha ng dalawang numero sa kahit anong ayos</p>
                            </div>
                            <div class="gameSelectPly">
                                <span><img src="./assets/img/icons/Frame (1).png" /></span>
                                <p>Ginaganap ang mga draw linggu-linggo tuwing Sabado ng 03:30 PM UTC.</p>
                            </div>
                            <div class="gameSelectPly">
                                <span><img src="./assets/img/icons/sustainability.png" /></span>
                                <p>Panoorin nang live ang draw sa aming YouTube channel at Facebook page</p>
                            </div>
                        </>

                    :
                        i18n.language === 'vi' ?
                                    <>
                                        <div class="gameSelectPly">
                                            <span><img src="./assets/img/icons/abt-1.png" /></span>
                                            <p>Mua với giá USD {appVariables.PRIZE_STRUCT_SUPERMEGA.BetAmount} để tham gia VÉ SỐ CHÍNH hằng tuần của chúng tôi chỉ trong một lần!</p>
                                        </div>
                                        <div class="gameSelectPly">
                                            <span><img src="./assets/img/icons/Select Icon.png" /></span>
                                            <p>Chọn {appVariables.PRIZE_STRUCT_SUPERMEGA.BallSelectCount} số - Chọn trong khoảng từ {appVariables.PRIZE_STRUCT_SUPERMEGA.StartBall} đến {appVariables.PRIZE_STRUCT_SUPERMEGA.EndBall} cho mỗi vé. Hoặc bạn có thể nhấp vào biểu tượng ngẫu nhiên "∝" và chúng tôi sẽ chọn số cho bạn.</p>
                                        </div>
                                        <div class="gameSelectPly">
                                            <span><img src="./assets/img/icons/Stars Icon.png" /></span>
                                            <p>Ghép các số theo BẤT KỲ THỨ TỰ nào để trúng Giải Đặc Biệt trị giá USD {appVariables.PRIZE_STRUCT_SUPERMEGA.MainDrawWin.FstPrize.replace('#', ' Million')}*</p>
                                        </div>
                                        <div class="gameSelectPly">
                                            <span><img src="./assets/img/icons/Winner Icon.png" /></span>
                                            <p>Mỗi người trúng thưởng sẽ nhận được giải khi ghép được hai số theo bất kỳ thứ tự nào</p>
                                        </div>
                                        <div class="gameSelectPly">
                                            <span><img src="./assets/img/icons/Frame (1).png" /></span>
                                            <p>Kỳ quay số diễn ra hằng tuần vào mỗi thứ Bảy lúc 03:30 tối (UTC).</p>
                                        </div>
                                        <div class="gameSelectPly">
                                            <span><img src="./assets/img/icons/sustainability.png" /></span>
                                            <p>Xem trực tiếp kỳ quay số trên kênh YouTube và trang Facebook của chúng tôi</p>
                                        </div>
                                    </>


                                    :
                                    i18n.language === 'id' ?
                                    <>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/abt-1.png" /></span>
                                                    <p>Beli seharga USD {appVariables.PRIZE_STRUCT_SUPERMEGA.BetAmount} untuk ikut serta dalam UNDIAN UTAMA mingguan kami sekaligus!</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Select Icon.png" /></span>
                                                    <p>Pilih {appVariables.PRIZE_STRUCT_SUPERMEGA.BallSelectCount} Angka - Pilih antara {appVariables.PRIZE_STRUCT_SUPERMEGA.StartBall} hingga {appVariables.PRIZE_STRUCT_SUPERMEGA.EndBall} per tiket. Atau, Anda bisa klik ikon acak "∝" dan kami akan memilihkan angka untuk Anda.</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Stars Icon.png" /></span>
                                                    <p>Cocokkan angka dalam URUTAN APA SAJA untuk memenangkan Hadiah Utama sebesar USD {appVariables.PRIZE_STRUCT_SUPERMEGA.MainDrawWin.FstPrize.replace('#', ' Million')}*</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Winner Icon.png" /></span>
                                                    <p>Setiap pemenang menerima hadiah dengan mencocokkan dua angka dalam urutan apa saja</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Frame (1).png" /></span>
                                                    <p>Undian berlangsung setiap minggu pada hari Sabtu pukul 03:30 Waktu Standar India (UTC).</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/sustainability.png" /></span>
                                                    <p>Saksikan undian langsung di saluran YouTube dan halaman Facebook kami</p>
                                                </div>
                                            </>

                                        :
                                        i18n.language === 'km' ?
                                            <>
                                                    <div class="gameSelectPly">
                                                        <span><img src="./assets/img/icons/abt-1.png" /></span>
                                                        <p>ទិញក្នុងតម្លៃ USD {appVariables.PRIZE_STRUCT_SUPERMEGA.BetAmount} ដើម្បីចូលរួមក្នុងការចាប់ឆ្នោតធំប្រចាំសប្តាហ៍របស់យើងក្នុងមួយដង!</p>
                                                    </div>
                                                    <div class="gameSelectPly">
                                                        <span><img src="./assets/img/icons/Select Icon.png" /></span>
                                                        <p>ជ្រើសរើស {appVariables.PRIZE_STRUCT_SUPERMEGA.BallSelectCount} លេខ - ជ្រើសរវាង {appVariables.PRIZE_STRUCT_SUPERMEGA.StartBall} ដល់ {appVariables.PRIZE_STRUCT_SUPERMEGA.EndBall} សម្រាប់មួយសំបុត្រ។ ឬ អ្នកអាចចុចលើរូបតំណាងចៃដន្យ "∝" ហើយយើងនឹងជ្រើសលេខសម្រាប់អ្នក។</p>
                                                    </div>
                                                    <div class="gameSelectPly">
                                                        <span><img src="./assets/img/icons/Stars Icon.png" /></span>
                                                        <p>ផ្គូផ្គងវានៅក្នុងលំដាប់ណាមួយ ដើម្បីឈ្នះរង្វាន់ធំ USD {appVariables.PRIZE_STRUCT_SUPERMEGA.MainDrawWin.FstPrize.replace('#', ' Million')}*</p>
                                                    </div>
                                                    <div class="gameSelectPly">
                                                        <span><img src="./assets/img/icons/Winner Icon.png" /></span>
                                                        <p>អ្នកឈ្នះនីមួយៗនឹងទទួលបានរង្វាន់ ដោយផ្គូផ្គងលេខពីរនៅក្នុងលំដាប់ណាមួយ</p>
                                                    </div>
                                                    <div class="gameSelectPly">
                                                        <span><img src="./assets/img/icons/Frame (1).png" /></span>
                                                        <p>ការចាប់ឆ្នោតត្រូវបានប្រារព្ធឡើងប្រចាំសប្តាហ៍រៀងរាល់ថ្ងៃសៅរ៍ ម៉ោង 03:30 យប់ (UTC)</p>
                                                    </div>
                                                    <div class="gameSelectPly">
                                                        <span><img src="./assets/img/icons/sustainability.png" /></span>
                                                        <p>មើលការចាប់ឆ្នោតផ្ទាល់នៅលើឆានែល YouTube និងទំព័រ Facebook របស់យើង</p>
                                                    </div>
                                                </>


                                            :
                                            <>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/abt-1.png" /></span>
                                                    <p>Purchase for USD {appVariables.PRIZE_STRUCT_SUPERMEGA.BetAmount} to enter our weekly MAIN DRAW in one go!</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Select Icon.png" /></span>
                                                    <p>Pick {appVariables.PRIZE_STRUCT_SUPERMEGA.BallSelectCount} Numbers - Select between {appVariables.PRIZE_STRUCT_SUPERMEGA.StartBall} to {appVariables.PRIZE_STRUCT_SUPERMEGA.EndBall} per ticket. Or, you can click on the randomization "∝" icon and we select your numbers for you. </p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Stars Icon.png" /></span>
                                                    <p>Match them in ANY ORDER to win Grand Prize of USD {appVariables.PRIZE_STRUCT_SUPERMEGA.MainDrawWin.FstPrize.replace('#', ' Million')}*.</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Winner Icon.png" /></span>
                                                    <p>Each winner receives a prize amount by matching two numbers in any order</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/Frame (1).png" /></span>
                                                    <p> Draws take place weekly on every Saturday at 03:30 PM UTC.</p>
                                                </div>
                                                <div class="gameSelectPly">
                                                    <span><img src="./assets/img/icons/sustainability.png" /></span>
                                                    <p> Catch the draw live on our YouTube channel and Facebook page</p>
                                                </div>
                                            </>
                                }
            </div>

        )
    }
}



function mapStateToProps(state) {
    const { user } = state.loginReducer;
    return { user };
}
const mapActionToProps = {
    logout: loginActions.logout
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Aboutsupermega))